module.exports = __webpack_public_path__ + "img/pAbout-banner.c48bb7ee.jpg";